import { useQuery } from '@tanstack/react-query';

import { notificationApi } from '@/api';

/**
 * The unread count beside the Notifications menu item.
 *
 * Shares the header bell's query key, so the two always agree and the menu
 * costs no request of its own -- the bell's poll keeps both fresh.
 */
export function NotificationCountBadge() {
  const { data } = useQuery({
    queryKey: ['notification-count'],
    queryFn: notificationApi.getUnreadCount,
  });

  const unread = data?.total ?? 0;
  if (!unread) return null;

  return (
    <span
      className="bg-brand-600 ml-2 inline-flex min-w-5 items-center justify-center rounded-full px-1.5 py-0.5 text-xs font-medium text-white"
      aria-label={`${unread} unread`}
    >
      {unread > 99 ? '99+' : unread}
    </span>
  );
}
